<template>
  <b-overlay :show="isLoading">
    <b-card v-if="faqDetails">
      <h1 class="mb-2">ویرایش سوالات متداول</h1>
      <b-row>
        <b-col cols="12">
          <faq-category-picker
            :defaultCategoryId="faqDetails.faqCategoryId"
            @getCategory="setCategory"
          ></faq-category-picker>
        </b-col>
        <b-col cols="12">
          <b-form-group label="نامک (URL)" label-for="slug">
            <b-form-input
              id="slug"
              placeholder="post-ads-registration-conditions"
              v-model.trim="faqDetails.slug"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="متن سوال" label-for="questionText">
            <b-form-input
              id="questionText"
              placeholder="شرایط ثبت آگهی در فرادیدار"
              v-model="faqDetails.questionText"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="خلاصه جواب" label-for="summary">
            <b-form-textarea
              id="summary"
              v-model.trim="faqDetails.answerTextSummery"
              placeholder="خلاصه‌ی جواب برای نمایش در صفحات دسته بندی"
              rows="3"
              max-rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="متن جواب" label-for="answerText" class="mb-2">
            <ckEditorMain
              ref="ckEditor"
              id="answerText"
              :isRenderingSourceButton="false"
              @getEditorContent="setEditorContent"
              :defaultContent="faqDetails.answerText"
            ></ckEditorMain>
          </b-form-group>
        </b-col>
        <b-col cols="12" align-self="end">
          <div class="w-100 d-flex align-items-center justify-content-end">
            <b-button
              :disabled="isSubmitButtonDisabled"
              variant="primary"
              @click="updateASingleQuestionAnswer"
            >
              ویرایش
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>
<script>
export default {
  mounted() {
    this.getASingleQuestionAnswer();
  },
  data() {
    return {
      isLoading: false,
      faqDetails: null,
    };
  },
  methods: {
    async updateASingleQuestionAnswer() {
      try {
        this.isLoading = true;
        const _this = this;
        let updateAFaqQuestionAnswer = new UpdateAFaqQuestionAnswer(_this);
        updateAFaqQuestionAnswer.setParams(_this.faqDetails);
        await updateAFaqQuestionAnswer.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "ویرایش شد!",
                icon: "EditIcon",
                variant: "success",
                text: "سوال با موفقیت ویرایش شد",
              },
            });
            _this.getASingleQuestionAnswer();
          } else {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "خطا در ویرایش سوال",
                icon: "XIcon",
                variant: "danger",
                text: res.errorMessage,
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getASingleQuestionAnswer() {
      try {
        this.isLoading = true;
        const _this = this;
        let getASingleFaqQuestionAnswer = new GetASingleFaqQuestionAnswer(
          _this
        );
        getASingleFaqQuestionAnswer.setParams({ id: _this.$route.params.id });
        await getASingleFaqQuestionAnswer.fetch((res) => {
          _this.faqDetails = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setEditorContent(content) {
      this.faqDetails.answerText = content;
    },
    setCategory(catObject) {
      if (catObject && catObject.id) {
        this.faqDetails.faqCategoryId = catObject.id;
      } else {
        this.faqDetails.faqCategoryId = null;
      }
    },
  },
  computed: {
    isSubmitButtonDisabled() {
      if (
        this.faqDetails &&
        this.faqDetails.faqCategoryId &&
        this.faqDetails.questionText &&
        this.faqDetails.slug &&
        this.faqDetails.answerTextSummery &&
        this.faqDetails.answerText
      ) {
        return false;
      }
      return true;
    },
  },
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BTabs,
    BTab,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BFormTextarea,
    BPagination,
    BFormGroup,
    BForm,
    BModal,
    FaqCategoryPicker,
    ckEditorMain,
  },
};

import ckEditorMain from "@core/components/ckEditorMain.vue";
import FaqCategoryPicker from "@/@core/utils/FaqCategoryPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  GetASingleFaqQuestionAnswer,
  UpdateAFaqQuestionAnswer,
} from "@/libs/Api/FaqQuestionAnswer/FaqQuestionAnswer";
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BTabs,
  BTab,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormTextarea,
  BPagination,
  BFormGroup,
  BForm,
  BModal,
} from "bootstrap-vue";
</script>
